import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let time_tracking = new BaseTableModule('/ws/human_user_contract/');

const state = {
    ...time_tracking.state,
    columns: [
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'Active', value: 'active', sortable: false, filterable: true, divider: true, brief: true, width: 50},
        {text: 'Name', value: 'name', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'User', value: 'user__employee_number', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'From', value: 'from_date', sortable: true, filterable: true, divider: true, brief: true, width: 80},
        {text: 'To', value: 'to_date', sortable: true, filterable: true, divider: true, brief: true, width: 80},
        {text: 'Working house', value: 'working_hours', sortable: false, filterable: true, divider: true, brief: true, width: 300},
        {text: 'Holiday offset', value: 'holiday_offset', sortable: false, filterable: true, divider: true, brief: true, width: 50,},
        {text: 'Holiday per year', value: 'holiday_per_year', sortable: false, filterable: true, divider: true, brief: true, width: 50,},
        {text: 'Time offset', value: 'time_offset', sortable: false, filterable: true, divider: true, brief: true, width: 50,},
        {text: 'Comment', value: 'comment', sortable: false, filterable: true, divider: true, brief: true,},

        {text: 'Created on', value: 'created_on', sortable: false, divider: true, brief: true,},
        {text: 'Created by', value: 'created_by', sortable: true, divider: true, brief: true,},

        {text: 'Edited on', value: 'edited_on', sortable: false, divider: true, brief: true,},
        {text: 'Edited by', value: 'edited_by', sortable: false, divider: true, brief: true,},
    ],
    columns_brief: [
        {text: 'Active', value: 'active', sortable: false, filterable: true, divider: true, brief: true, width: 50},
        {text: 'Name', value: 'name', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'From', value: 'from_date', sortable: true, filterable: true, divider: true, brief: true, width: 80},
        {text: 'To', value: 'to_date', sortable: true, filterable: true, divider: true, brief: true, width: 80},
        {text: 'Working house', value: 'working_hours', sortable: false, filterable: true, divider: true, brief: true, width: 300},
        {text: 'Holiday offset', value: 'holiday_offset', sortable: false, filterable: true, divider: true, brief: true, width: 50,},
        {text: 'Holiday per year', value: 'holiday_per_year', sortable: false, filterable: true, divider: true, brief: true, width: 50,},
        {text: 'Time offset', value: 'time_offset', sortable: false, filterable: true, divider: true, brief: true, width: 50,},
        {text: 'Comment', value: 'comment', sortable: false, filterable: true, divider: true, brief: true,},
    ],

    briefView: true,
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['user__employee_number'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
    local_phrase: {
        // tracker: {en: 'tracker', de: 'Tracker', color: 'grey darken-1', class: 'timer'},
    },

};
const getters = {
    ...time_tracking.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns_brief
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...time_tracking.actions,
};
const mutations = {
    ...time_tracking.mutations,
};

export default {
    modules: {
        Contract: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}